// eslint-disable-next-line camelcase
import { document_url } from '@/plugins/checklist_api'
export default {
  methods: {
    getDropAreaItems (fieldDropPanel) {
      let newElementColumn = 0
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        var listOfAllActiveFieldsWithValues = []
        if (children.length) {
          children.forEach(child => {
            if (child.classList.length) listOfAllActiveFieldsWithValues.push({ columns: parseInt(child.classList[1].split('-')[2]) })
          })
        }
        let rowReferenceObj = { currentRowOccupiedColumns: 0 }
        listOfAllActiveFieldsWithValues.forEach((field, index) => {
          rowReferenceObj.currentRowOccupiedColumns += field.columns
          let tempColumns = rowReferenceObj.currentRowOccupiedColumns
          if ((index + 1) !== listOfAllActiveFieldsWithValues.length) tempColumns += listOfAllActiveFieldsWithValues[index + 1].columns
          if (tempColumns > 12) rowReferenceObj.currentRowOccupiedColumns = 0
        })
        newElementColumn = 12 - rowReferenceObj.currentRowOccupiedColumns
        newElementColumn = newElementColumn === 0 ? 12 : newElementColumn
        var div = document.createElement('div')
        div.setAttribute('class', `col-md-${newElementColumn}`)
        div.setAttribute('style', 'border: 3px dashed #1fb2aa;')
        fieldDropPanel.appendChild(div)
        this.$root.$emit('setFieldColumn', newElementColumn)
      }
    },
    // eslint-disable-next-line camelcase
    mimeTypeOfAttachment ({ file_original_name, file_guid }) {
      let image = ''
      let ext = file_original_name.split('.').pop()
      let extension = ext ? ext.toString().toLowerCase() : ''
      switch (extension) {
        case 'png':
        case 'jpeg':
        case 'jpg':
        case 'gif':
          // eslint-disable-next-line camelcase
          image = { icon: 'mdi-file-image', color: null, url: `${document_url}/Documents/${file_guid}?t=${new Date().getTime()}` }
          break
        default:
          image = { icon: 'mdi-file-document', color: null, url: null }
          break
      }
      return image
    }
  }
}
